import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { WidgetModalEditRetiroComponent } from './widget-modal-edit-retiro.component';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxLoadingModule } from 'ngx-loading';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WidgetToastModule } from '../widget-toast/widget-toast.module';


@NgModule({
  declarations: [WidgetModalEditRetiroComponent],
  exports: [WidgetModalEditRetiroComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatTabsModule,
    NgbModule,
    NgxLoadingModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetToastModule
  ],
})
export class WidgetModalEditRetiroModule { }
